/**
 * Ticket LM11: Vorschaubild beim Teilen – eine Stelle für alle Seiten.
 *
 * Die Veranstaltungsseite hat diesen Weg zuerst gebraucht (absolute Adresse,
 * sonst gar kein Bild). Damit daneben kein zweiter Weg entsteht, liegt die
 * Bauweise der Angaben jetzt hier und wird von Veranstaltungen und Freebies
 * gemeinsam genutzt.
 *
 * Ohne Bild bleibt es beim bisherigen Verhalten: keine Bildangabe, kleine
 * Kartenform. Ein Platzhalter sieht in einer Vorschau schlechter aus als keiner.
 */

export type ShareMetaEntry = { name?: string; property?: string; content: string };

export function shareImageMeta(imageUrl: string | null | undefined): ShareMetaEntry[] {
  const url = (imageUrl ?? "").trim();
  // Nur absolute Adressen: Vorschaudienste laden keine relativen Pfade.
  if (!url.startsWith("https://")) {
    return [{ name: "twitter:card", content: "summary" }];
  }
  return [
    { property: "og:image", content: url },
    { name: "twitter:image", content: url },
    { name: "twitter:card", content: "summary_large_image" },
  ];
}
